let popupWindow: Window | null = null;

export function set(ref: Window | null) {
  popupWindow = ref;
}

export function get() {
  return popupWindow;
}
